import loginBg from '@/assets/icons/login-bg.png';
import integrationCrmJobber from '@/assets/icons/onboarding_crm_jobber.png';
import { PrimaryButton } from '@/components/buttons/primary-button';
import { AlloSquareLogo } from '@/components/logos/allo-logo';
import { H4, P2 } from '@/components/ui/text';
import { useTranslation } from '@/hooks/use-translation';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CheckCircle2 } from 'lucide-react';

export const Route = createFileRoute('/jobber/connected')({
  component: JobberConnectedComponent,
});

function JobberConnectedComponent() {
  const { t } = useTranslation('desktop_ui');
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate({
      to: '/settings/integrations/$integrationName',
      params: { integrationName: 'jobber' },
    });
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url("${loginBg}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-[480px] bg-white rounded-2xl p-8 pt-10 shadow-sm">
          <div className="flex flex-col items-center gap-6">
            {/* Logos section */}
            <div className="flex items-center gap-4">
              <img
                src={integrationCrmJobber}
                alt="Jobber logo"
                className="h-16 w-16 rounded-2xl object-contain"
              />
              <div className="flex items-center justify-center">
                <CheckCircle2 className="h-8 w-8 text-green-500" />
              </div>
              <AlloSquareLogo />
            </div>

            {/* Success message */}
            <div className="text-center space-y-2">
              <H4 className="text-primary-100">{t('jobber.connected.title')}</H4>
              <P2 className="text-primary-60 max-w-sm">{t('jobber.connected.description')}</P2>
            </div>

            {/* CTA Button */}
            <PrimaryButton onClick={handleContinue} className="w-full max-w-xs h-12 rounded-2xl">
              {t('jobber.connected.cta')}
            </PrimaryButton>

            {/* Additional info */}
            <P2 className="text-primary-40 text-center max-w-sm">{t('jobber.connected.info')}</P2>
          </div>
        </div>
      </div>
    </div>
  );
}
